<ion-content class="success-modal-content">
  <div class="success-container">
    <div class="success-icon"></div>
    <div class="success-title">{{ message || ('fabric_inspection_start_inspection.complete' | translate) }}</div>
  </div>
</ion-content>
